import React, { useState } from 'react';
import { DateTime } from 'src_common/utils/time/time';
import { observer } from 'src/utils/mobx-react';
import {
    TableRow,
    TableCell,
    ReasonWrapper,
    ReasonItem,
    ReasonShow,
    StatusWrapper,
    ActionSelect,
    LiNotSelectedAction,
    DropdownActionPlaceholder,
    DropdownULAction,
    ChevronDownWrapper,
} from './AffordabilityExcludedRequests.style';
import { useAppStateContext } from 'src/AppState/AppState';
import { OpenapiProxyStaffAccountAffordabilityFetchAllResponse200Type as ResponseType } from 'src/api_openapi/generated/openapi_proxy_staff_account_affordability_fetch_all';
import { useClickOutside } from 'src/utils/hooks/useClickOutside';
import { AffordabilityExcludedState } from 'src/AppState/AffordabilityExcludedState';
import { AffordabilityExcludedRequestsRowState } from './AffordabilityExcludedRequestsRow.state';

type ResponseDataInferredType = ResponseType['data'] extends Array<infer Data> ? Data : never;

interface AffordabilityExcludedRequestsRowPropsType {
    affordabilityExcludedElement: ResponseDataInferredType;
    affordabilityExcludedState: AffordabilityExcludedState;
}

export const AffordabilityExcludedRequestsRow = observer(
    'AffordabilityExcludedRequestsRow',
    (props: AffordabilityExcludedRequestsRowPropsType): React.ReactElement | null => {
        const appState = useAppStateContext();
        const { affordabilityExcludedElement, affordabilityExcludedState } = props;

        const [state] = useState(
            () =>
                new AffordabilityExcludedRequestsRowState(
                    affordabilityExcludedState,
                    affordabilityExcludedElement.accountId
                )
        );

        const [setParticularActionRef] = useClickOutside({ callback: state.closeParticularAction });

        const trimmedReason = (): React.ReactElement | null => {
            if (affordabilityExcludedElement.reason !== null && affordabilityExcludedElement.reason !== undefined) {
                if (state.showMore === false) {
                    return (
                        <ReasonWrapper>
                            <p>{affordabilityExcludedElement.reason.substring(0, 30)}&nbsp;&nbsp;&nbsp;</p>

                            {affordabilityExcludedElement.reason.length > 30 ? (
                                <ReasonShow onClick={state.toggleShowMore}>Show more</ReasonShow>
                            ) : null}
                        </ReasonWrapper>
                    );
                } else {
                    return (
                        <ReasonWrapper>
                            <ReasonItem>{affordabilityExcludedElement.reason}</ReasonItem>
                            <ReasonShow onClick={state.toggleShowMore}>Show less</ReasonShow>
                        </ReasonWrapper>
                    );
                }
            }
            return null;
        };

        const onClick = (): void => {
            appState.reduxAction.customersActionsOpenRequest(affordabilityExcludedElement.accountId);
        };

        return (
            <TableRow section={affordabilityExcludedState.activeTab}>
                <TableCell
                    isClickable={false}
                    cellWidth={16.6}
                >
                    {affordabilityExcludedElement.accountId}
                </TableCell>
                <TableCell
                    isClickable={false}
                    cellWidth={16.6}
                >
                    {DateTime.from(affordabilityExcludedElement.lastCheckDate)?.format('DD/MM/YYYY HH:mm') ?? '-'}
                </TableCell>
                <TableCell
                    isClickable={true}
                    onClick={onClick}
                    cellWidth={16.6}
                >
                    {affordabilityExcludedElement.firstName} {affordabilityExcludedElement.lastName}
                </TableCell>
                <TableCell
                    isClickable={false}
                    cellWidth={16.6}
                >
                    <StatusWrapper color={affordabilityExcludedElement.affordabilityColor}>
                        {affordabilityExcludedElement.affordabilityColor}
                    </StatusWrapper>
                </TableCell>
                <TableCell
                    onClick={state.toggleParticularAction}
                    isClickable={false}
                    cellWidth={16.6}
                >
                    <ActionSelect ref={setParticularActionRef}>
                        <DropdownActionPlaceholder>
                            {'Select'}
                            <ChevronDownWrapper />
                        </DropdownActionPlaceholder>
                        {state.particularAction ? (
                            <DropdownULAction>
                                <LiNotSelectedAction onClick={state.handleCheckOne}>
                                    {'Mark As Reviewed'}
                                </LiNotSelectedAction>
                            </DropdownULAction>
                        ) : null}
                    </ActionSelect>
                </TableCell>
                <TableCell
                    isClickable={false}
                    cellWidth={16.6}
                >
                    {trimmedReason()}
                </TableCell>
            </TableRow>
        );
    }
);
